import React, { useState, useEffect, useCallback, useRef } from 'react';
import classnames from 'classnames';
import { SearchBox, Button } from 'tea-component';
import NavHeader from '@/pages/home/components/NavHeader';
import '@/pages/home/assets/scss/page/home/components/headerContext.scss';
import { useIntl, useSelector, getLocale, useHistory } from 'umi';
import { v4 as uuidv4 } from 'uuid';
import {
  fetchSearchTrendings,
  fetchSearchPullDown,
  deleteHistory,
  fetchAddSearchHistory,
} from '@/pages/home/services/search';
import {
  goToSearchPageUrl,
  DEFAULT_SEARCH_PARAMS,
  useMountedRef,
  getHighLine,
} from '@/pages/home/utils/search';
import { getTrendingGames } from '@/pages/home/components/NavHeader/components/search';
import { CompleteOptionsType, RecentResultType } from '@/pages/home/types/home';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { debounce } from 'lodash-es';
import { buriedBtnPoint } from '@home/utils/buriedPoint';
import { dbhAISearchSwitchBtnLogMes } from '@home/utils/buriedPointCfg';
import NoData from '@/pages/intelligence/components/NoData';
import useSearchModel from '@home/hooks/useSearchModel';
import useCronExpressionCalc from '@home/hooks/useCronExpressionCalc';
import useYearlyPosterNew from './useYearlyPosterNew';
import AISearchSwitch, { getAISearchEnabled } from './AISearchSwitch';
import AISearchList from './AISearchList';
import RobotBanner from './RobotBanner';
import { logAISearchButtonClick } from '@home/components/AINavigation/utils/log';
import AIPageNavigationLoading from '@home/components/AINavigation/components/AIPageNavigationLoading';
import AIPageNavigationError from '@home/components/AINavigation/components/AIPageNavigationError';
import useIntelligencePageAIAccess from '@home/components/AINavigation/_hooks/useIntelligencePageAIAccess';
import { SEARCH_HISTORY_TYPE } from '@home/_config/constant';
import { DATABRAIN_AGENT_ID2, STORAGE_KEY } from '@/pages/aigc/pages/Agent/config/constant';

// 注意这里临时固定创建个局部showYearlyPoster固定为false，通过这样的方式同时保留两种逻辑代码，又能临时固定走指定分支逻辑代码，保不齐后续产品有需要加回另外一种处理逻辑的话，只需要把这行代码删除即可
const showYearlyPoster = false;

const getModuleScrollTop = (targetClassName: string, dom: HTMLElement): number => {
  const els = dom?.querySelector('.hame-page-scroll .tea-row .tea-col:first-of-type .tea-grid__box')?.children;

  if (!els) {
    return 0;
  }

  let top = 0;
  for (const el of els) {
    if (el?.classList.contains(targetClassName)) {
      break;
    }

    const computedStyle = getComputedStyle(el, null);
    const height = Number.parseFloat(computedStyle?.height);
    const marginTop = Number.parseFloat(computedStyle?.marginTop);
    const marginBottom = Number.parseFloat(computedStyle?.marginBottom);
    const paddingTop = Number.parseFloat(computedStyle?.paddingTop);
    const paddingBottom = Number.parseFloat(computedStyle?.paddingBottom);
    top += (height + marginTop + marginBottom + paddingTop + paddingBottom);
  }

  return top;
};

export default function HeaderContext(props: any) {
  const { studioList, ScollRef, showYearlyPosterLoading = true, holidayExpanded, onToggleHoliday } = props;
  const { formatMessage } = useIntl(); // 中英切换方法

  const {
    // AI Page Navigation数据 加载状态
    aiNavigationLoading,
    // AI Page Navigation数据 加载异常
    aiNavigationError,
    // 点击情报页面AI直达按钮的处理方法
    onIntelligencePageAIAccessClick,
    // 点击"回到搜索"按钮
    onIntelligencePageAIAccessBackClick,
    resetIntelligencePageAIAccessError,
  } = useIntelligencePageAIAccess({
    onNavigation: () => {
      setisfocus(false);
    },
    onBackClick: () => {
      // 保持 focus 状态，回退到之前的搜索状态
      setisfocus(true);
    },
  });

  const [inputValue, setInputValue] = useState('');
  // const [open, setOpen] = useState(false);
  const [value, setValue] = useState(0);
  const [focus, setisfocus] = useState(false);
  // const [openTrending, setOpenTrending] = useState(true);
  const [hotGameList, setHotGameList] = useState<any[]>([]);
  const [hotGameChList, setHotGameChList] = useState<any[]>([]);
  const [hotGameEnList, setHotGameEnList] = useState<any[]>([]);
  // const [openSure, setOpenSure] = useState(false);
  const [recentResult, setRecentResult] = useState<RecentResultType[]>([]);
  const [newResult, setNewResult] = useState([]);
  const [completeOptions, setCompleteOptions] = useState<CompleteOptionsType[]>([]);
  // AI Search 开关状态
  const [aiSearchEnabled, setAiSearchEnabled] = useState<boolean>(() => getAISearchEnabled());

  const { visible: creatorTopChartsNewVisible, onClose: handleCloseCreatorTopChartsNewVisible } = useCronExpressionCalc(
    'creator_topcharts_new_cron_expression',
  );

  const { visible: yearlyPosterVisible, onClose: handleCloseYearlyPosterVisible } =
    useYearlyPosterNew(showYearlyPoster);

  const { userInfo } = useSelector((state: any) => {
    const { userInfo } = state.home;
    return {
      userInfo,
    };
  });
  const mountedRef = useMountedRef();
  const localeText = getLocale();

  // 搜索框范围
  const refSearch = useRef<any>(null);
  // 搜索面板范围（包含 AISearchSwitch 和 SearchBox）
  const refSearchPanel = useRef<any>(null);
  // 下拉框范围
  const reUlLi = useRef<any>(null);
  // home-header-flex 容器 ref
  const headerFlexRef = useRef<HTMLDivElement>(null);
  // RobotBanner ref
  const robotBannerRef = useRef<RobotBannerRef>(null);
  const history = useHistory();
  // 点击外部区域关闭弹窗,自定义模拟搜索下拉关闭与打开,阻止冒泡事件首页home搜索
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      // 如果不在搜索面板范围内（包含 AISearchSwitch 和 SearchBox）
      if (refSearchPanel.current && !refSearchPanel.current?.contains(event.target)) {
        // 同时不在下拉框范围内
        if (reUlLi.current && !reUlLi.current?.contains(event.target)) {
          // 主动关闭下拉
          setisfocus(false);
        }
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  // SameStartDate接口调用hooks
  const {
    openTrending,
    setOpenTrending,
    getOpenTrendingStatus,
    setOpenTrendingStatus,
    searchTrendingList,
    trendingList,
    recentList,
    searchList,
    isShowTrending,
    isSearchPullNoData,
  } = useSearchModel({ completeOptions, inputValue });

  // 删除某个搜索历史记录
  const deleteHistoryHandle = async (id: any, e: any) => {
    e.stopPropagation();
    const params = {
      open_id: userInfo?.openid,
      history_id: Number(id),
    };
    try {
      const result: any = await deleteHistory(params);
      if (result?.code === 0) {
        getSearchPullDown(inputValue !== '' ? inputValue : ' ');
      }
    } catch (err) {
    } finally {
    }
  };

  const turnCompletePullList = () => {
    const tempOptionsList: any = [];
    const recentTempList: any = [];
    const resultTempList: any = [];

    recentResult.forEach((item, index) => {
      const searchType = item.search_type || SEARCH_HISTORY_TYPE.Game;

      if (
        !aiSearchEnabled &&
        (searchType === SEARCH_HISTORY_TYPE.AIAgent ||
          searchType === SEARCH_HISTORY_TYPE.AINavigation)
      ) {
        return;
      }

      recentTempList.push({
        groupKey: 'Recent',
        value: item.id,
        id: item.id,
        name: item.name,
        searchType,
        text: (
          <div className="recentResult" key={index}>
            <span
              dangerouslySetInnerHTML={{
                __html: getHighLine(item.name, inputValue),
              }}
            ></span>
            <Button
              icon="dismiss"
              onClick={(e) => {
                deleteHistoryHandle(item.id, e);
              }}
            />
          </div>
        ),
      });
    });
    recentTempList?.length > 0 && tempOptionsList.push(...recentTempList);
    newResult.forEach((item, index) => {
      resultTempList.push({
        groupKey: 'Search',
        value: item,
        name: item,
        id: item,
        text: (
          <div className="recentResult" key={index}>
            <span
              dangerouslySetInnerHTML={{
                __html: getHighLine(item, inputValue),
              }}
            ></span>
          </div>
        ),
      });
    });
    resultTempList?.length > 0 && tempOptionsList.push(...resultTempList);
    setCompleteOptions([
      ...getTrendingGames(searchTrendingList, localeText, inputValue),
      ...tempOptionsList,
    ]);
  };

  const handleOnFocus = () => {
    setTimeout(() => {
      setisfocus(true);
    }, 100);
  };

  // onSearch的调用方法
  const onSearchAutoCompleteHandle = (value: any) => {
    const keyword = value?.trim();

    if (aiSearchEnabled && !keyword) {
      return;
    }

    goToSearchPageUrl({ ...DEFAULT_SEARCH_PARAMS, kw: keyword });
    addSearchHistory(keyword);
  };

  // 输入input后的调用方法
  const onChangeSearchBoxHandle = (value: any) => {
    setInputValue(value);
    getSearchPullDown(value === '' ? ' ' : value);

    if (aiNavigationError && value.trim()) {
      resetIntelligencePageAIAccessError();
    }

    setisfocus(true);
  };

  const onChangeAutoCompleteObjHandle = (strTemp: any) => {
    setInputValue(strTemp?.name);

    goToSearchPageUrl({ ...DEFAULT_SEARCH_PARAMS, kw: strTemp?.name });
    addSearchHistory(strTemp?.name);
  };

  // 选择热搜词调用方法
  const onChangeHotHandle = (value: any) => {
    goToSearchPageUrl({ ...DEFAULT_SEARCH_PARAMS, kw: value });
    addSearchHistory(value);
  };

  // 获取首页搜索推荐信息
  const getSearchTrendings = async () => {
    const params = {
      search_type: 'all',
      page: 1,
      page_size: 20,
    };
    try {
      const resultData: any = await fetchSearchTrendings(params);
      const hotList = Array.isArray(resultData?.data) ? resultData?.data : [];
      // 添加三个需要显示2个月的，新上线的游戏Trending Games Datas
      // const hotList = addUpcomingTrendsGames(hotListTemp);
      const hotGameNameList: Array<string> = [];
      const hotGameNameListCh: Array<string> = [];
      for (const n in hotList) {
        if (Number.parseInt(n) < 5) {
          hotGameNameList.push(hotList[n]?.info?.entity_name || '');
          hotGameNameListCh.push(
            hotList[n].info?.entity_name_ch == ''
              ? hotList[n].info?.entity_name
              : hotList[n].info?.entity_name_ch,
          );
        }
      }
      setHotGameList(localeText === 'zh-CN' ? hotGameNameListCh : hotGameNameList);
      setHotGameChList(hotGameNameListCh);
      setHotGameEnList(hotGameNameList);
    } catch (err) {
    } finally {
    }
  };

  // 添加搜索记录，纯字符
  const addSearchHistory = (_text: String) => {
    fetchAddSearchHistory({
      open_id: userInfo?.openid,
      keyword: _text,
      info: {},
      search_type: SEARCH_HISTORY_TYPE.Game,
    });
  };

  const addAISearchHistory = (_text: String, searchType: string) => {
    fetchAddSearchHistory({
      open_id: userInfo?.openid,
      keyword: _text,
      info: {},
      search_type: searchType,
    });
  };

  const handleSearch = async (keyword: String) => {
    const params = {
      keyword,
      entity_type: 'all',
      system_type: 'pc',
      page: 1,
      page_size: 5,
    };
    try {
      const resultData: any = await fetchSearchPullDown(params);
      if (mountedRef.current) {
        // 当组件未卸载则set
        setNewResult(resultData?.result || []);
        setRecentResult(resultData?.recent_result || []);
      }
    } catch (err) {
    } finally {
    }
  };

  // 获取首页搜索下拉列表数据,用于搜索时请求的防抖
  const getSearchPullDown = useCallback(
    debounce((keyword: string) => {
      handleSearch(keyword);
    }, 500),
    [],
  );

  // 首次进入，先调用一次下拉列表
  useEffect(() => {
    getSearchPullDown(' ');
    getSearchTrendings();
    getOpenTrendingStatus();
  }, []);

  // 将 RobotBanner 的鼠标事件绑定到 home-header-flex 容器
  useEffect(() => {
    if (headerFlexRef.current && robotBannerRef.current) {
      robotBannerRef.current.attachToContainer(headerFlexRef.current);
    }
  }, []);

  // 任何搜索内容变化，更新下拉列表内容
  useEffect(() => {
    turnCompletePullList();
  }, [recentResult, newResult, localeText, aiSearchEnabled, searchTrendingList]);

  useEffect(() => {
    setHotGameList(localeText === 'zh-CN' ? hotGameChList : hotGameEnList);
  }, [localeText]);

  const handleTrending = (e: any) => {
    e.stopPropagation();
    setOpenTrending(!openTrending);
    setOpenTrendingStatus(!openTrending);
  };

  const handleTrendingItem = (e: any, item: any) => {
    onChangeAutoCompleteObjHandle(item);
    setisfocus(false);
  };

  const handleRecentItem = (e: any, item: any) => {
    e.stopPropagation();

    if (
      aiSearchEnabled &&
      (item?.searchType === SEARCH_HISTORY_TYPE.AIAgent ||
        item?.searchType === SEARCH_HISTORY_TYPE.AINavigation)
    ) {
      setInputValue(item?.name || '');
      getSearchPullDown(item?.name || ' ');
      setisfocus(true);
      return;
    }

    onChangeAutoCompleteObjHandle(item);
    setisfocus(false);
  };

  const screenBottom = () => {
    const top = showYearlyPoster
      ? getModuleScrollTop('dbh-yearly-poster', ScollRef.current)
      : getModuleScrollTop('dbh-leaderboard', ScollRef.current);
    ScollRef.current.scrollTo({
      // REMARK: 不要删除，2025年度表彰海报下架后，需要恢复下面这一行代码
      // top: ScollRef.current.children[0].offsetHeight,
      top,
      behavior: 'smooth', // 平滑滚动效果
    });

    buriedBtnPoint({
      buttonId: '100101004',
      extInfo: '数据达人荣誉榜快捷键',
      pageId: '100101',
      typeId: 'homePage_pc_v2',
    });

    if (showYearlyPoster) {
      if (!!yearlyPosterVisible) {
        handleCloseYearlyPosterVisible();
      }
    } else {
      if (!!creatorTopChartsNewVisible) {
        handleCloseCreatorTopChartsNewVisible();
      }
    }
  };

  // 清除input后的调用方法
  const onClearSearchBoxHandle = () => {
    setisfocus(true);
  };

  // AI Search 开关切换
  const handleAISearchChange = (active: boolean) => {
    setAiSearchEnabled(active);
  };

  // AI Search 列表项点击
  const handleAISearchItemClick = (type: 'agent' | 'navigation') => {
    const sessionId = uuidv4();
    const messageId = uuidv4();

    if (type === 'agent') {
      addAISearchHistory(inputValue.trim(), SEARCH_HISTORY_TYPE.AIAgent);

      const logInfo = {
        sessionId,
        mode: 'auto',
        modeId: DATABRAIN_AGENT_ID2,
        from: 'homeSearch',
        messageId,
        keywords: inputValue?.trim(),
      };

      logAISearchButtonClick({
        aiSearchType: 'ai_agent',
        data: logInfo,
      });

      // 埋点
      buriedBtnPoint({
        pageId: '700501',
        buttonId: '700501006',
        extInfo: JSON.stringify(logInfo),
        typeId: 'aigc',
      });

      // 设置 Agent 模式映射（将 DATABRAIN_AGENT_ID2 的模式设置为 auto）
      try {
        const agentModeMapKey = `__dba_agent_mode_map_${userInfo?.openid}__`;
        const agentModeMap = JSON.parse(localStorage.getItem(agentModeMapKey) || '{}');
        agentModeMap[DATABRAIN_AGENT_ID2] = 'auto';
        localStorage.setItem(agentModeMapKey, JSON.stringify(agentModeMap));
      } catch {
        // ignore
      }

      // 设置选中的 Agent（同步 __dba_selected_agent__ key）
      try {
        const selectedAgentKey = `${STORAGE_KEY}_${userInfo?.openid}__`;
        localStorage.setItem(selectedAgentKey, DATABRAIN_AGENT_ID2);
      } catch {
        // ignore
      }

      history.push({
        pathname: '/agent/chat',
        search: `?sessionId=${sessionId}`,
        state: {
          initialMessage: inputValue.trim(),
          messageId,
          from: 'homeSearch',
          serverParams: {
            model_id: DATABRAIN_AGENT_ID2,
            mode: 'auto',
          }
        },
      });
      setisfocus(false);
      return;
    }

    // 情报页面AI直达
    if (type === 'navigation') {
      addAISearchHistory(inputValue.trim(), SEARCH_HISTORY_TYPE.AINavigation);

      const params = {
        keyword: inputValue?.trim() || '',
      };
      void onIntelligencePageAIAccessClick(params);
      return;
    }
  };

  const renderDropdownBoxContent = () => {
    const shouldShowGamesSection = !!searchList?.length || (aiSearchEnabled && !isShowTrending);
    const shouldRenderDropdownList = !isSearchPullNoData || shouldShowGamesSection;

    // 情报页面AI直达加载态
    if (aiNavigationLoading) {
      return (
        <AIPageNavigationLoading
          text={formatMessage({ id: 'dbh_ai_search_page_navigating' })}
        />
      );
    }

    // 情报页面AI直达异常态
    if (aiNavigationError) {
      return (
        <AIPageNavigationError
          errorMessage={formatMessage({ id: 'dbh_ai_search_page_not_found' })}
          backText={formatMessage({ id: 'dbh_ai_search_page_back_to_search' })}
          onBack={onIntelligencePageAIAccessBackClick}
          onClose={() => {
            resetIntelligencePageAIAccessError();
            setisfocus(false);
          }}
        />
      );
    }

    return (
      <>
        {/* AI Search 列表 - 当开关开启且输入框有值时显示 */}
        {aiSearchEnabled && inputValue.trim() && (
          <AISearchList
            inputValue={inputValue}
            onItemClick={handleAISearchItemClick}
          />
        )}
        {shouldRenderDropdownList && (
          <ul
            className="tea-list tea-list--option tea-list--group"
            ref={reUlLi}
          >
            {isShowTrending && (
              <>
                <li
                  className={`tea-list__label tea-list__label--button ${
                    openTrending ? '' : '--closed'
                  }`}
                  onClick={handleTrending}
                >
                  <span>{formatMessage({ id: 'dbh_search_trending' })}</span>
                  <SvgIcon
                    className="dbh-home-header-trending-collapse-icon"
                    type={openTrending ? 'fill-icon-arrow' : 'fill-icon-arrow'}
                  />
                </li>
                {openTrending &&
                  trendingList?.map((item: any, index: number) => {
                    return (
                      <li
                        key={index}
                        onClick={(e) => {
                          handleTrendingItem(e, item);
                        }}
                      >
                        {item.text}
                      </li>
                    );
                  })}
              </>
            )}
            {!aiSearchEnabled && recentList?.length > 0 && (
              <>
                <li className="tea-list__label">
                  {formatMessage({ id: 'dbh_recent' })}
                </li>
                {recentList?.map((item: any, index: number) => {
                  return (
                    <li
                      key={index}
                      onClick={(e) => {
                        handleRecentItem(e, item);
                      }}
                    >
                      {item.text}
                    </li>
                  );
                })}
              </>
            )}
            {shouldShowGamesSection && (!aiSearchEnabled || inputValue?.trim()) && (
              <>
                <li
                  className={
                    aiSearchEnabled
                      ? 'tea-list__label dbh-search-group-title'
                      : 'tea-list__label'
                  }
                >
                  {formatMessage({ id: 'dbh_ai_search_games' })}
                </li>
                {searchList?.map((item: any, index: number) => {
                  return (
                    <li
                      key={index}
                      onClick={(e) => {
                        logAISearchButtonClick({
                          aiSearchType: 'game',
                          data: item,
                        });

                        handleTrendingItem(e, item);
                      }}
                    >
                      {item.text}
                    </li>
                  );
                })}
              </>
            )}
            {aiSearchEnabled && recentList?.length > 0 && (
              <>
                <li className="tea-list__label dbh-search-group-title dbh-search-group-title--with-divider">
                  {formatMessage({ id: 'dbh_recent' })}
                </li>
                {recentList?.map((item: any, index: number) => {
                  return (
                    <li
                      key={index}
                      onClick={(e) => {
                        logAISearchButtonClick({
                          aiSearchType: 'recent',
                          data: item,
                        });
                        handleRecentItem(e, item);
                      }}
                    >
                      {item.text}
                    </li>
                  );
                })}
              </>
            )}
          </ul>
        )}
        {isSearchPullNoData && (
          <NoData text={formatMessage({ id: 'dbi_no_results_found' })} />
        )}
      </>
    );
  };

  return (
    <div className="home-header">
      <NavHeader ifHasSearch={false} studioList={studioList} />
      <div className="home-header-flex" ref={headerFlexRef}>
        <RobotBanner containerRef={headerFlexRef} />
        <div className="home-header-tab">
          <div
            className={value == 0 ? 'home-header-action' : 'home-header-text'}
            onClick={() => {
              setValue(0);
            }}
          >
            {/* 设计走查内容， 让先注释 */}
            {/* {formatMessage({ id: 'dbh_explore' })} */}
          </div>
          {/* <div className={value == 1 ? 'home-header-action' : 'home-header-text'} onClick={() => { setValue(1) }}>
            {formatMessage({ id: 'dbh_following' })}
          </div> */}
        </div>
        {showYearlyPosterLoading || (
          <div
            className={classnames('home-header-back-honer', { 'home-header-back-honer--cn': localeText === 'zh-CN', 'show-yearly-poster': showYearlyPoster, 'show-yearly-poster--cn': localeText === 'zh-CN' })}
            onClick={screenBottom}
          >
            <span className="home-header-back-honer-text">
              {formatMessage({ id: showYearlyPoster ? 'dbh_autocomplete_yearly_poster' : 'dbh_autocomplete_data_lover' })}
            </span>
            {(creatorTopChartsNewVisible || yearlyPosterVisible) && (
              <span className="home-header-back-honer-icon-new">{formatMessage({ id: 'dbh_new' })}</span>
            )}
          </div>
        )}
        <div className="home-header-search">
          <div className="home-header-autoComplete dbh-search-panel" ref={refSearchPanel}>
            <div className={`dbh-search-box-wrapper dbh-search-box-wrapper--home ${
              focus ? 'dbh-search-box-wrapper-focus' : ''
            } ${aiSearchEnabled ? 'dbh-search-box-wrapper--enabled' : ''} ${aiSearchEnabled && focus ? 'dbh-search-box-wrapper--active' : ''} ${!focus && inputValue ? 'dbh-search-box-wrapper--has-value' : ''}`}>
              <div className="dbh-search-box-wrapper__inner">
                <SearchBox
                  className={`home-header-searbox lay-nav-search-tip ${
                    focus ? 'home-header-focus' : ''
                  }`}
                  ref={refSearch}
                  onSearch={onSearchAutoCompleteHandle}
                  value={inputValue}
                  onChange={onChangeSearchBoxHandle}
                  onClear={onClearSearchBoxHandle}
                  onHelp={() => console.log('help')}
                  placeholder={formatMessage({ id: aiSearchEnabled ? 'dbh_ai_search_input_placeholder' : 'dbh_search_placeholder' })}
                  onFocus={handleOnFocus}
                />
                <AISearchSwitch
                  isActive={aiSearchEnabled}
                  onChange={handleAISearchChange}
                  buttonLogConfig={dbhAISearchSwitchBtnLogMes.homeHeader}
                />
              </div>
            </div>
            <div
              className={`${
                focus ? 'tea-dropdown-box--show' : 'tea-dropdown-box--hide'
              } tea-dropdown-box dbh-search-dropdown-home`}
            >
              <div className="tea-dropdown-box-inner">{renderDropdownBoxContent()}</div>
            </div>
          </div>

          <div className="home-header-searchTab">
            {hotGameList.length > 0 ? (
              <>
                <SvgIcon className="home-header-searchTab-icon" type="flame-icon" />
                {hotGameList?.map((item: any, index: number) =>
                  item ? (
                    <div
                      key={`searchHotTab-${index}`}
                      className="home-header-searchTab-item"
                      onClick={() => {
                        onChangeHotHandle(item);
                      }}
                    >
                      {item}
                    </div>
                  ) : (
                    ''
                  ),
                )}
              </>
            ) : (
              <div className="home-header-nohot"></div>
            )}
          </div>
        </div>
        {/* <div className="home-header-null"></div> */}
      </div>
      {onToggleHoliday && (
        <div
          className={`dbh-header-holiday-btn`}
          onClick={onToggleHoliday}
        >
          <span className="dbh-header-holiday-btn__icon" />
          <span className="dbh-header-holiday-btn__text">
            {formatMessage({ id: 'dbh_global_holidays' })}
          </span>
          <SvgIcon
            type="fill-icon-arrow"
            className={`dbh-header-holiday-btn__arrow${holidayExpanded ? ' dbh-header-holiday-btn__arrow--up' : ''}`}
          />
        </div>
      )}
    </div>
  );
}
